<template>
  <div class="ws-static-locale-update">
    <v-form class="ws-static-locale-update__form">
      <v-row class="">
        <v-col class="">名詞</v-col>
        <v-col class="">翻譯</v-col>
      </v-row>
      <v-row
        v-for="(languItem,languIndex) in value"
        :key="languIndex"
      >
        <v-col>{{languItem.label}}</v-col>
        <v-col>
          <div
            v-if="$_alert(languItem.translate)"
            class="ws-static-locale-update__form__alert"
          >
            {{$_alert(languItem.translate)}}
          </div>
          <WsState
            type="text"
            :value="languItem.translate"
            @input="$_onInput($event,languIndex)"
          />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
export default {
  methods: {
    $_alert(item) {
      if (item.indexOf("{") != -1 || item.indexOf("}") != -1) {
        return `請勿將'{ }'內的文字刪除`;
      } else {
        return null;
      }
    },
    $_onInput($event, index) {
      const _value = [...this.value];
      _value[index].translate = $event;
      this.$emit("input", _value);
    },
  },
  props: {
    value: {
      type: Array,
    },
  },
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/ws-static-locale-update.scss";
</style>